import { LoadableLazy } from '@confluence/loadable';

export const ConfluenceAiInEditorModalWithErrorBoundaryLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceAiInEditorModalWithErrorBoundary" */ '../src/ui/AiInEditorModal/index.tsx'
			)
		).ConfluenceAiInEditorModalWithErrorBoundary,
});
